var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-header",
        [
          _vm._v(" Ticket Details "),
          _vm.ticket.ticketstatustitle == "In Progress"
            ? _c(
                "v-chip",
                {
                  staticClass: "ma-2",
                  attrs: {
                    label: "",
                    color: "green",
                    "text-color": "white"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.ticket.ticketstatustitle) + " ")]
              )
            : _vm.ticket.ticketstatustitle == "Closed"
            ? _c(
                "v-chip",
                {
                  staticClass: "ma-2",
                  attrs: {
                    label: "",
                    color: "red",
                    "text-color": "white"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.ticket.ticketstatustitle) + " ")]
              )
            : _c(
                "v-chip",
                {
                  staticClass: "ma-2",
                  attrs: {
                    label: ""
                  }
                },
                [_vm._v(" " + _vm._s(_vm.ticket.ticketstatustitle) + " ")]
              ),
          _vm.validated
            ? _c(
                "v-icon",
                {
                  staticClass: "mb-2 ml-1",
                  attrs: {
                    size: "20",
                    color: "primary"
                  }
                },
                [_vm._v("mdi-check-circle")]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "gg-card-text",
        [
          _c(
            "v-list",
            [
              _c(
                "v-list-item",
                [
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-subtitle", [
                        _c("strong", [_vm._v("Subject")])
                      ]),
                      _c("v-list-item-title", [
                        _vm._v(" " + _vm._s(_vm.ticket.subject) + " ")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-subtitle", [
                        _c("strong", [_vm._v("Ticket ID")])
                      ]),
                      _c("v-list-item-title", [
                        _vm._v(" " + _vm._s(_vm.ticket.ticketmaskid) + " ")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-subtitle", [
                        _c("strong", [_vm._v("Department")])
                      ]),
                      _c("v-list-item-title", [
                        _vm._v(" " + _vm._s(_vm.ticket.departmenttitle) + " ")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-subtitle", [
                        _c("strong", [_vm._v("Related Service")])
                      ]),
                      _c("v-list-item-title", [
                        _vm._v(
                          " " + _vm._s(_vm.ticket.related_service_text) + " "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }